import { compose, prop } from 'ramda';
import { branch, mapProps, renderComponent } from 'recompose';
import { componentService } from 'js/services/component.service';
import { withPortlet, usePortletConfig } from 'js/components/system/Portlet';
import { useDeviceSelector } from 'js/store/hooks';

import {
    LEADER_BOARD_SLIDER,
    RACE_REGISTRATION_STATUSES,
    RACE_STATUSES,
    RACES_REQUESTS
} from './constants';
import OverflowSlider from './OverflowSlider';
import LeaderBoardSlider from './LeaderBoardSlider';
import withLeaderBoardList from './withLeaderBoardList';
import withSortedList from './withSortedList';

export const Slider = compose(
    withPortlet({
        forLoggedIn: true
    }),
    mapProps((props) => {
        const {
            racesRequest,
            raceIDs: leaderboardIds = [],
            gameCode: game,
            raceStatuses = 'both',
            raceRegistrationStatuses = 'all'
        } = usePortletConfig();
        const isRequestByID = racesRequest === RACES_REQUESTS.byIDs;

        if (leaderboardIds.length && isRequestByID) {
            return {
                ...props,
                leaderboardIds
            };
        }

        const nextProps = {
            ...props,
            filterByStatus: RACE_STATUSES[isRequestByID ? 'both' : raceStatuses],
            filterByRegistrationStatus: RACE_REGISTRATION_STATUSES[isRequestByID ? 'all' : raceRegistrationStatuses]
        };

        if (game) {
            return {
                ...nextProps,
                game
            };
        }

        return nextProps;
    }),
    withLeaderBoardList,
    withSortedList,
    branch(
        () => useDeviceSelector(prop('isDesktop')),
        renderComponent(LeaderBoardSlider)
    )
)(OverflowSlider);

componentService.registerPageComponents({ [LEADER_BOARD_SLIDER]: Slider });
